import React from 'react'
import styled from 'styled-components'

import { ReactComponent as ErrorIcon } from '@/assets/svgs/alert-house-plant.svg'
import { useDecideRoute } from '@/hooks/useDecideRoute'
import { ROUTES } from '@/routes/routes'
import { Button } from '@/UIkit/Button'

import {
  AssistanceSection,
  InformationSection,
  InformationSectionTitle,
  Layout,
} from '../../components'
import { theme } from '../../theme'
import { AccommodationApp } from '../accommodation/AccommodationApp'
import { LoginApp } from '../login/LoginApp'
import { LoadingSpinner, MFAApp } from '../mfa/MFAApp'
import { ShortlistApp } from '../shortlist/ShortlistApp'

const LogInButton = styled(Button)`
  margin-top: 24px;
  padding-top: 17px;
  padding-bottom: 17px;
`

export const TaskPaneApp = () => {
  const { isReady, intendedRoute, forceRoute, forceUpdateRoute } =
    useDecideRoute()

  let content = null
  if (!isReady) {
    content = (
      <Layout largeLogo>
        <InformationSection>
          <LoadingSpinner size={32} color={theme.colors.primaryDefault} />
          <InformationSectionTitle>Checking emails...</InformationSectionTitle>
          Please wait while we verify the email.
        </InformationSection>
        <AssistanceSection />
      </Layout>
    )
  }
  switch (intendedRoute) {
    case ROUTES.MFA:
      content = <MFAApp forceRoute={forceRoute} />
      break
    case ROUTES.SHORTLIST:
      content = <ShortlistApp />
      break
    case ROUTES.LOGIN:
      content = <LoginApp onUpdateRoute={forceUpdateRoute} />
      break
    case ROUTES.HOUSING_REQUEST:
      content = <AccommodationApp />
      break
    case ROUTES.INCOMPATIBLE_EMAIL:
    default:
      content = (
        <Layout largeLogo>
          <InformationSection
            title="Not a valid request email"
            iconProps={{ iconComponent: ErrorIcon, width: 175, height: 150 }}
          >
            <div>
              We couldn’t find any housing request details. Try selecting a
              different email.
            </div>
            <LogInButton
              mode="primary"
              isFullWidth
              onClick={() => forceRoute(ROUTES.LOGIN)}
            >
              Log in
            </LogInButton>
          </InformationSection>
          <AssistanceSection />
        </Layout>
      )
      break
  }

  return content
}
